import { createAction } from 'redux-actions';

const actions = {
  /**
   *  데이터 변경하기
   */
  SET_DATA: 'remoteImage/SET_DATA',
  setData: createAction('remoteImage/SET_DATA'),

  /**
   *  원격 스플래시 이미지 리스트 요청하기
   */
  GET_REMOTE_IMAGE_SPLASH_LIST_REQUEST: 'remoteImage/GET_REMOTE_IMAGE_SPLASH_LIST_REQUEST',
  GET_REMOTE_IMAGE_SPLASH_LIST_SUCCESS: 'remoteImage/GET_REMOTE_IMAGE_SPLASH_LIST_SUCCESS',
  getRemoteImageSplashList: createAction('remoteImage/GET_REMOTE_IMAGE_SPLASH_LIST_REQUEST'),

  /**
   *  원격 레퍼럴 이미지 리스트 요청하기
   */
  GET_REMOTE_IMAGE_REFERRAL_LIST_REQUEST: 'remoteImage/GET_REMOTE_IMAGE_REFERRAL_LIST_REQUEST',
  GET_REMOTE_IMAGE_REFERRAL_LIST_SUCCESS: 'remoteImage/GET_REMOTE_IMAGE_REFERRAL_LIST_SUCCESS',
  getRemoteImageReferralList: createAction('remoteImage/GET_REMOTE_IMAGE_REFERRAL_LIST_REQUEST'),

  /**
   *  원격 스플래시 이미지 상세 정보 요청하기
   */
  GET_REMOTE_IMAGE_SPLASH_DETAIL_REQUEST: 'remoteImage/GET_REMOTE_IMAGE_SPLASH_DETAIL_REQUEST',
  GET_REMOTE_IMAGE_SPLASH_DETAIL_SUCCESS: 'remoteImage/GET_REMOTE_IMAGE_SPLASH_DETAIL_SUCCESS',
  getRemoteImageSplashDetail: createAction('remoteImage/GET_REMOTE_IMAGE_SPLASH_DETAIL_REQUEST'),

  /**
   *  원격 레퍼럴 이미지 상세 정보 요청하기
   */
  GET_REMOTE_IMAGE_REFERRAL_DETAIL_REQUEST: 'remoteImage/GET_REMOTE_IMAGE_REFERRAL_DETAIL_REQUEST',
  GET_REMOTE_IMAGE_REFERRAL_DETAIL_SUCCESS: 'remoteImage/GET_REMOTE_IMAGE_REFERRAL_DETAIL_SUCCESS',
  getRemoteImageReferralDetail: createAction('remoteImage/GET_REMOTE_IMAGE_REFERRAL_DETAIL_REQUEST'),

  /**
   *  원격 스플래시 이미지 등록 요청하기
   */
  CREATE_REMOTE_IMAGE_SPLASH_REQUEST: 'remoteImage/CREATE_REMOTE_IMAGE_SPLASH_REQUEST',
  createRemoteImageSplash: createAction('remoteImage/CREATE_REMOTE_IMAGE_SPLASH_REQUEST'),

  /**
   *  원격 레퍼럴 이미지 등록 요청하기
   */
  CREATE_REMOTE_IMAGE_REFERRAL_REQUEST: 'remoteImage/CREATE_REMOTE_IMAGE_REFERRAL_REQUEST',
  createRemoteImageReferral: createAction('remoteImage/CREATE_REMOTE_IMAGE_REFERRAL_REQUEST'),

  /**
   *  원격 스플래시 이미지 수정 요청하기
   */
  EDIT_REMOTE_IMAGE_SPLASH_REQUEST: 'remoteImage/EDIT_REMOTE_IMAGE_SPLASH_REQUEST',
  editRemoteImageSplash: createAction('remoteImage/EDIT_REMOTE_IMAGE_SPLASH_REQUEST'),

  /**
   *  원격 레퍼럴 이미지 수정 요청하기
   */
  EDIT_REMOTE_IMAGE_REFERRAL_REQUEST: 'remoteImage/EDIT_REMOTE_IMAGE_REFERRAL_REQUEST',
  editRemoteImageReferral: createAction('remoteImage/EDIT_REMOTE_IMAGE_REFERRAL_REQUEST'),
};

export default actions;
